import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-picker-anchor-button top-right" }


import { actionHandler } from '@/actions/actionHandler';
import { Action } from '@/components/TableComponent/types';
import { usePatientsStore } from '@/store/patients/patientsModule';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';

const __default__ = {
  name: 'DatePickerAnchorButton',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const action: Action = {
  type: 'modal',
  name: 'DateRangePickerModal',
};

const handler = () => {
  actionHandler(action);
};

const { dates } = storeToRefs(usePatientsStore());

const label = computed(() => `${dates.value.date_from} ~ ${dates.value.date_till}`);

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_btn, {
      color: "accent",
      flat: "",
      label: _unref(label),
      onClick: handler
    }, null, 8, ["label"])
  ]))
}
}

})